const { Button } = require("reactstrap");

function customerColumns(handleEdit, handleDelete, handleTransaction) {
  return [
    {
      Header: "Customer Name",
      accessor: "name",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Phone",
      accessor: "phone",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Email",
      accessor: "email",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => <span>{value ? value : "-"}</span>,
    },
    {
      Header: "Discount (per ltr)",
      accessor: "discount",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
        <span
          className={`badge ${value !== "0.00" ? "bg-success" : "bg-warning"}`}
        >
          {value !== "0.00" ? `₹ ${value}` : "No Discount"}
        </span>
      ),
    },
    {
      Header: "Orders",
      accessor: "Orders",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
          {value ? value.length : "no orders"}
        </span>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
          {value ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      Header: "Total Remaining",
      accessor: "total_remaining",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Credit Balance",
      accessor: "credit_balance",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Actions",
      accessor: "actions",
      disableFilters: true,
      filterable: false,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          {handleEdit && (
            <button
              onClick={() => handleEdit(row.original)}
              className="btn btn-sm btn-primary"
            >
              Edit
            </button>
          )}
          {handleDelete && (
            <button
              onClick={() => handleDelete(row.original)}
              className="btn btn-sm btn-danger"
            >
              Delete
            </button>
          )}
          {handleTransaction && (
            <button
              onClick={() => handleTransaction(row.original)}
              className="btn btn-sm btn-warning"
            >
              Transaction
            </button>
          )}
        </div>
      ),
    },
  ];
}

export default customerColumns;
